import { read_sass_offer_registration_id } from './sass_offer_identity';

// Replaces every meeting-date alias used by SASS cards and response normalization.
export const read_sass_offer_with_meeting_date = (offerItem = {}, meetingDate = '') => {
    const dateFields = {
        true: {
            sassMeetingDate: meetingDate
        },
        false: {}
    }[Boolean(meetingDate)];
    const nifflerDateFields = {
        true: {
            meetingDate
        },
        false: {}
    }[Boolean(meetingDate)];

    return {
        ...offerItem,
        setupData: {
            ...(offerItem?.setupData || {}),
            ...dateFields
        },
        typesData: {
            ...(offerItem?.typesData || {}),
            ...dateFields
        },
        niffler: {
            ...(offerItem?.niffler || {}),
            ...nifflerDateFields,
            client: {
                ...(offerItem?.niffler?.client || {}),
                ...nifflerDateFields
            }
        }
    };
};

// Refreshes the open card only while the user still has that same card selected.
export const read_sass_selected_offer_after_refresh = (selectedOffer, updatedOffer = {}) => {
    if (!selectedOffer) {
        return selectedOffer;
    }

    if (read_sass_offer_registration_id(selectedOffer) !== read_sass_offer_registration_id(updatedOffer)) {
        return selectedOffer;
    }

    return updatedOffer;
};
